import { render, staticRenderFns } from "./M12_S30.vue?vue&type=template&id=a0b90c20&scoped=true"
import script from "./M12_S30.vue?vue&type=script&lang=js"
export * from "./M12_S30.vue?vue&type=script&lang=js"
import style0 from "./M12_S30.vue?vue&type=style&index=0&id=a0b90c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b90c20",
  null
  
)

export default component.exports